import { type ExportTemplateDTO } from '@framework/api-client/api/backoffice/schemas/exportTemplateDTO.ts';
import { type ExportTemplateDTOType } from '@framework/api-client/api/backoffice/schemas/exportTemplateDTOType.ts';
import { Select } from '@framework/ui/components/select/Select.tsx';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExportTemplateDeleteModalButton } from './ExportTemplateDeleteModalButton.tsx';

export interface ExportTemplateSelectProps {
  options: Array<{ label: string; value: string | null | undefined }>;
  isLoading: boolean;
  setSelectedTemplate: (value: string) => void;
  onSelect: (fields: string[]) => void;
  data: ExportTemplateDTO[] | undefined;
  selectedTemplate?: string | null;
  exportTemplateType?: ExportTemplateDTOType;
}

/**
 * Componente per la selezione del template di esportazione
 */
export function ExportTemplateSelect(props: ExportTemplateSelectProps) {
  const {
    options,
    isLoading,
    setSelectedTemplate,
    selectedTemplate,
    onSelect,
    exportTemplateType,
    data,
  } = props;

  const { t } = useTranslation();

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        style={{ width: '100%' }}
        placeholder={t(
          'export-template-select.select-template-to-export',
          'Carica campi da Template',
        )}
        allowClear
        loading={isLoading}
        value={selectedTemplate != '' ? selectedTemplate : undefined}
        options={options}
        onClear={() => {
          setSelectedTemplate('');
          onSelect([]);
        }}
        onChange={(selected: string) => {
          if (!selected) return;

          setSelectedTemplate(selected);
          const foundTemplate = data?.find(item => item.id === selected);
          const parsed: string[] = JSON.parse(foundTemplate?.template ?? '[]');
          onSelect(parsed);
        }}
        optionFilterProp="label"
      />
      <ExportTemplateDeleteModalButton
        templateId={selectedTemplate}
        exportTemplateType={exportTemplateType}
        setSelectedTemplate={setSelectedTemplate}
        onDelete={onSelect}
      />
    </Space.Compact>
  );
}
